import React from 'react';
import { Colorway } from '@uds/theme-utils';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';

import getClassNames from './Caveat.stylesheet';

interface OuterProps {
  colorway: Colorway;
  body: ShortcodeProps;
}

const PureCaveat = ({ colorway, body }: OuterProps) => {
  const classNames = getClassNames();
  return (
    <p className={classNames.root}>
      <Shortcode colorway={colorway} code={body} />
    </p>
  );
};

PureCaveat.displayName = 'LegalCaveat';

export default PureCaveat;
